import { VACCINATION_CONST } from '@/const';
import { ApiPlugin } from '@/plugins';

export default class Vaccination {
  static getVaccinationFilters() {
    // Only get the enabled filters.
    if (window?.API && window.API['vaccination-results-page']?.filters) {
      const vaccinationFilters = VACCINATION_CONST.FILTERS;
      const enabledFilters = window.API.result || window.API['vaccination-results-page'].filters;
      return vaccinationFilters.filter((filter) => enabledFilters.includes(filter.value));
    }

    return [];
  }

  static getVaccinationCentersResults() {
    if (window?.API && window.API['vaccination-results-page']?.result) {
      return window.API.result || window.API['vaccination-results-page'].result;
    }

    return undefined;
  }

  static async getAvailableDepartments() {
    try {
      const viteMaDoseDepUrl = window?.drupalSettings?.viteMaDose?.viteMaDoseDepUrl;
      // Unable to retrieve ViteMaDose API URL return empty Object
      if (!viteMaDoseDepUrl) {
        throw new Error('Unable to retrieve ViteMaDose URL');
      }

      const response = await ApiPlugin.get(viteMaDoseDepUrl);
      return response.data ?? {};
    } catch (e) {
      console.error(e);
      return {};
    }
  }
}
